import { render, staticRenderFns } from "./ApprovedDispatchedInvoicesTable.vue?vue&type=template&id=6ad4673d&scoped=true"
import script from "./ApprovedDispatchedInvoicesTable.vue?vue&type=script&lang=js"
export * from "./ApprovedDispatchedInvoicesTable.vue?vue&type=script&lang=js"
import style0 from "./ApprovedDispatchedInvoicesTable.vue?vue&type=style&index=0&id=6ad4673d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad4673d",
  null
  
)

export default component.exports